export class LoadEvent {
  static readonly type = '[Event] Load Event';

  constructor(readonly slug: string) {}
}
